import { AimOutlined } from "@ant-design/icons";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export interface MessageConfidenceProps {
  confidence: number;
  confidenceThreshold: number;
}

export default function MessageConfidence({ confidence, confidenceThreshold }: MessageConfidenceProps): ReactElement {
  const { t } = useTranslation();

  const isConfidenceLow = confidence < confidenceThreshold;

  return (
    <Confidence
      $error={isConfidenceLow}
      aria-label={t("transcript.confidenceInTranscription")}
    >
      <AimOutlined aria-hidden />
      <span>{Math.round(confidence * 100)}%</span>
    </Confidence>
  );
}

const Confidence = styled.div<{ $error: boolean }>`
  display: flex;
  align-items: center;
  gap: ${p => p.theme.paddingXXS}px;
  
  font-size: ${p => p.theme.fontSizeSM}px;
  color: ${p => p.$error ? p.theme.colorError : p.theme.colorTextSecondary};
`;
